module.exports = __webpack_public_path__ + "img/btn-pagetop.bb2a5fdd.svg";